document.addEventListener("DOMContentLoaded", function () {
  window.handheld =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
  document.documentElement.classList.remove("no-js");

  /* Avoid form resubmission on refresh */
  if (window.history.replaceState) {
    window.history.replaceState(null, null, window.location.href);
  }

  /* Manage drawer accessibility (inert and aria-expanded) */
  const drawers = document.querySelectorAll(
    '#mainmenu-drawer, [tabindex="-1"][aria-labelledby*="drawer"]'
  );
  drawers.forEach((drawer) => {
    const syncInert = () => {
      const isHidden =
        drawer.getAttribute("aria-hidden") === "true" ||
        drawer.classList.contains("translate-x-full") ||
        drawer.classList.contains("-translate-x-full") ||
        drawer.classList.contains("translate-y-full") ||
        drawer.classList.contains("-translate-y-full");
      if (isHidden) {
        drawer.setAttribute("inert", "");
      } else {
        drawer.removeAttribute("inert");
      }
      const triggers = document.querySelectorAll(
        `[data-drawer-target="${drawer.id}"], [data-drawer-show="${drawer.id}"]`
      );
      triggers.forEach((trigger) => {
        trigger.setAttribute("aria-expanded", (!isHidden).toString());
      });
    };
    syncInert();
    const observer = new MutationObserver(syncInert);
    observer.observe(drawer, {
      attributes: true,
      attributeFilter: ["aria-hidden", "class"],
    });
  });
});

